import { useQuery } from '@tanstack/react-query';
import {
    fetchContinuousData,
    isValidContinuousDataRange
} from '../services/continuousData';

export const useContinuousData = ({ patientUuid, dtype, startTimestamp, endTimestamp }) =>
    useQuery({
        queryKey: [
            'patient-continuous-data',
            'table-v2',
            patientUuid,
            dtype,
            startTimestamp,
            endTimestamp
        ],
        queryFn: ({ signal }) =>
            fetchContinuousData({
                patient: patientUuid,
                dtype,
                startTimestamp,
                endTimestamp,
                signal
            }),
        enabled: Boolean(
            patientUuid &&
                dtype &&
                isValidContinuousDataRange(startTimestamp, endTimestamp)
        ),
        staleTime: 60 * 1000
    });
